
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anti-scraping",
      function () {
        return require("private-next-pages/anti-scraping.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anti-scraping"])
      });
    }
  